import { useOOGlobals } from '../OOGlobalsProvider/OOGlobalsProvider'

// In a separate file so we can mock "useFlag"
// in tests
export const useFlag = (name, defaultValue = false) => {
  const { enabledFeatureFlags } = useOOGlobals()
  if (Array.isArray(enabledFeatureFlags) && enabledFeatureFlags.includes(name)) {
    return true
  }
  return defaultValue
}
